import './upcoming.scss'

import { Card, NoContentBox, useGet } from '@enkla-gui'

import React from 'react'
import { icons } from '@config'
import moment from 'moment'

export default function UpcomingWeek() {
  const { loading, data: events } = useGet({ endpoint: `api/stats/upcoming-week` })

  // Helper to render links
  const renderLink = (url, text) => (
    <a href={url} className="upcoming-link">
      {text}
    </a>
  )

  // Group events by day
  const groupedEvents = {}
    ; (events || []).forEach(event => {
      const eventDate = moment(event.date * 1000)
      const dayKey = eventDate.format('YYYY-MM-DD')
      if (!groupedEvents[dayKey]) {
        groupedEvents[dayKey] = {
          label: eventDate.format('dddd D MMMM'),
          events: []
        }
      }
      groupedEvents[dayKey].events.push(event)
    })

  // Get icon and colors for event type
  const getEventStyle = (type) => {
    switch (type) {
      case 'LEASE_IN':
        return { icon: 'fa-plus', bgColor: '#e8f5e9', color: '#2e7d32' }
      case 'LEASE_OUT':
        return { icon: 'fa-minus', bgColor: '#ffebee', color: '#c62828' }
      case 'MAINTENANCE':
        return { icon: 'fa-wrench', bgColor: '#e3f2fd', color: '#1565c0' }
      default:
        return { icon: 'fa-info-circle', bgColor: '#f5f5f5', color: '#757575' }
    }
  }

  // Render event content with optional action button
  const renderEventContent = (event) => {
    const tenantUrl = `#!/tenant/${event.tenant_id || ''}`
    const entityUrl = `#!/entity/${event.entity_id || ''}`
    const leaseUrl = `#!/lease/${event.lease_id || ''}`

    const isLeaseEvent = event.type === 'LEASE_IN' || event.type === 'LEASE_OUT'

    let text
    switch (event.type) {
      case 'LEASE_IN':
        text = <>
          Uthyrning för {renderLink(tenantUrl, event.tenant_name)} på {renderLink(entityUrl, event.entity_name)} börjar
        </>
        break
      case 'LEASE_OUT':
        text = <>
          Uthyrning för {renderLink(tenantUrl, event.tenant_name)} på {renderLink(entityUrl, event.entity_name)} upphör
        </>
        break
      case 'MAINTENANCE':
        text = <>
          {event.description} på {renderLink(entityUrl, event.entity_name)}
        </>
        break
      default:
        text = null
    }

    return (
      <>
        <div className="upcoming-event-text">{text}</div>
        {isLeaseEvent && (
          <a href={leaseUrl} className="upcoming-event-action">
            <i className="fas fa-arrow-right"></i>
          </a>
        )}
      </>
    )
  }

  return (
    <Card
      title="Din kommande vecka"
      buttons={{
        header: [{ link: `#!/calendar`, icon: icons.calendar, text: 'Visa kalender' }]
      }}
      icon={icons.calendar}
      loading={loading}
    >
      {Object.keys(groupedEvents).length === 0 ? (
        <NoContentBox text='Inga händelser är planerade den kommande veckan.' icon='fas fa-check' />
      ) : (
        <div className="upcoming-timeline">
          {Object.entries(groupedEvents).map(([dayKey, day]) => (
            <div key={dayKey} className="upcoming-day">
              <div className="upcoming-day-header">{day.label}</div>
              <div className="upcoming-events">
                {day.events.map((event, idx) => {
                  const style = getEventStyle(event.type)
                  return (
                    <div key={`${event.type}-${event.date}-${idx}`} className="upcoming-event">
                      <div
                        className="upcoming-event-icon"
                        style={{ backgroundColor: style.bgColor, color: style.color }}
                      >
                        <i className={`fas ${style.icon}`}></i>
                      </div>
                      <div className="upcoming-event-content">
                        {renderEventContent(event)}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  )
}
